/* tslint:disable */
/* eslint-disable */
/* @relayHash 8d070d9c6987a423f73c0ab10a31738a */

import { ConcreteRequest } from "relay-runtime";
export type CourseStatus = "complete" | "failed" | "incomplete" | "%future added value";
export type queries_ActiveDelegatesQueryVariables = {
    courseID: number;
    name?: string | null;
    offset: number;
    limit: number;
};
export type queries_ActiveDelegatesQueryResponse = {
    readonly activeCourseTakers: {
        readonly edges: ReadonlyArray<{
            readonly user: {
                readonly firstName: string;
                readonly lastName: string;
                readonly email: string | null;
            };
            readonly status: CourseStatus | null;
            readonly progress: {
                readonly total: number;
                readonly completed: number;
            } | null;
        } | null> | null;
        readonly pageInfo: {
            readonly total: number;
            readonly limit: number;
            readonly offset: number;
            readonly given: number;
        } | null;
    } | null;
};
export type queries_ActiveDelegatesQuery = {
    readonly response: queries_ActiveDelegatesQueryResponse;
    readonly variables: queries_ActiveDelegatesQueryVariables;
};



/*
query queries_ActiveDelegatesQuery(
  $courseID: Int!
  $name: String
  $offset: Int!
  $limit: Int!
) {
  activeCourseTakers(page: {offset: $offset, limit: $limit}, filter: {courseID: $courseID, name: $name}) {
    edges {
      user {
        firstName
        lastName
        email
      }
      status
      progress {
        total
        completed
      }
    }
    pageInfo {
      total
      limit
      offset
      given
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "courseID",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "name",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "offset",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "limit",
            "type": "Int!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "activeCourseTakers",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "filter",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "courseID",
                            "variableName": "courseID"
                        },
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        }
                    ]
                },
                {
                    "kind": "ObjectValue",
                    "name": "page",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit"
                        },
                        {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset"
                        }
                    ]
                }
            ],
            "concreteType": "TakersPage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TakerResponse",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "status",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "progress",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Progress",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "completed",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "limit",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "offset",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "given",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_ActiveDelegatesQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v2 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_ActiveDelegatesQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v2 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "queries_ActiveDelegatesQuery",
            "id": null,
            "text": "query queries_ActiveDelegatesQuery(\n  $courseID: Int!\n  $name: String\n  $offset: Int!\n  $limit: Int!\n) {\n  activeCourseTakers(page: {offset: $offset, limit: $limit}, filter: {courseID: $courseID, name: $name}) {\n    edges {\n      user {\n        firstName\n        lastName\n        email\n      }\n      status\n      progress {\n        total\n        completed\n      }\n    }\n    pageInfo {\n      total\n      limit\n      offset\n      given\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'eb2f5c666a117a10a2ecf9038a79cecd';
export default node;
